import sampleOptenPartner from './opten-sample.js';
function searchSuccessCallbackFactory(ctrl) {
	return function (response) {
		if (ctrl.addEmptyLastElement) {
			sampleOptenPartner.showName = ctrl.$filter('translator')('opten_notFound');
			sampleOptenPartner.Name = ctrl.$filter('translator')('opten_notFound');
			sampleOptenPartner.name = ctrl.$filter('translator')('opten_notFound');
			response.items.push(sampleOptenPartner);
		}
		ctrl.suggestedPartners = response.items;
		ctrl.searchLoading = false;
		ctrl.tooMuchRequest = false;
	};
}
export default searchSuccessCallbackFactory;
